<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog" id="modalEmrTreatUpload">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
              <span>Upload Phiếu</span>
            </div>
            <!-- <button
            type="button"
            class="close bg-white border-0"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              class="fs-30 fw-500"
            >&times;</span>
            </button>-->
          </div>
          <div class="modal-body">
            <div class="row mt-2">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 mb-3">
                    <div class="form-group">
                      <label class="fs-16 fw-500 txt-grey-900 required"
                        >Tên Phiếu</label
                      >
                      <input
                        type="text"
                        class="form-control mt-2 txt-grey-900 fs-16 fw-500"
                        placeholder="Nhập tên phiếu"
                        v-model="form.name"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 mb-3">
                    <div class="form-group">
                      <label class="fs-16 fw-500 txt-grey-900 required"
                        >Phiếu ngày</label
                      >
                      <!-- <el-date-picker
                        type="datetime"
                        placeholder="Chọn ngày giờ"
                        v-model="form.date"
                      ></el-date-picker>-->
                      <input
                        type="datetime-local"
                        class="form-control"
                        v-model="form.date"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 mb-3">
                    <div class="form-group">
                      <label class="fs-16 fw-500 txt-grey-900"
                        >Người tạo phiếu</label
                      >
                      <el-select
                        v-model="form.user_id"
                        filterable
                        allow-create
                        remote
                        reserve-keyword
                        placeholder="Tìm kiếm tên bác sĩ"
                        class="w-100"
                        :remote-method="getDoctor"
                        :loading="loadingDoctor"
                      >
                        <el-option
                          v-for="item in doctors"
                          :key="item.id + 'dtr'"
                          :label="item.name"
                          :value="item.user_id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-sm-12 mb-3">
                    <div class="form-group">
                      <label class="fs-16 fw-500 txt-grey-900"
                        >Khoa điều trị</label
                      >
                      <input
                        type="text"
                        class="form-control mt-2 txt-grey-900 fs-16 fw-500"
                        placeholder="Khoa điều trị"
                        v-model="form.treatment_workspace"
                      />
                    </div>
                  </div>
                  <div
                    class="col-sm-12 d-flex justify-content-between align-items-center flex-wrap"
                  >
                    <p class="mb-0">
                      {{ file ? file.name : "Chưa chọn file..." }}
                    </p>
                    <p
                      v-if="file"
                      style="border-bottom: solid 1.5px #20419b"
                      @click="onShowPickFile()"
                      class="cursor-pointer txt-grey-900 d-flex mb-0"
                    >
                      Thay đổi
                    </p>
                    <button
                      v-if="!file"
                      class="btn radius-0 d-flex align-items-center bg-pri bd-pri text-white fs-16 fw-500 mr-2 text-right"
                      @click="onShowPickFile()"
                    >
                      <svg
                        width="16"
                        height="20"
                        viewBox="0 0 16 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.78945 6.42495L7.31161 4.50829V12.5C7.31161 12.721 7.38164 12.9329 7.50629 13.0892C7.63095 13.2455 7.80002 13.3333 7.9763 13.3333C8.15259 13.3333 8.32166 13.2455 8.44632 13.0892C8.57097 12.9329 8.641 12.721 8.641 12.5V4.50829L10.1632 6.42495C10.2249 6.50306 10.2985 6.56506 10.3795 6.60736C10.4605 6.64967 10.5473 6.67145 10.6351 6.67145C10.7228 6.67145 10.8097 6.64967 10.8907 6.60736C10.9717 6.56506 11.0452 6.50306 11.107 6.42495C11.1693 6.34749 11.2188 6.25532 11.2525 6.15377C11.2863 6.05222 11.3036 5.9433 11.3036 5.83329C11.3036 5.72328 11.2863 5.61436 11.2525 5.51281C11.2188 5.41126 11.1693 5.31909 11.107 5.24162L8.44824 1.90829C8.38502 1.83242 8.31048 1.77295 8.22889 1.73329C8.06706 1.64994 7.88555 1.64994 7.72372 1.73329C7.64213 1.77295 7.56759 1.83242 7.50437 1.90829L4.84559 5.24162C4.78361 5.31932 4.73445 5.41156 4.70091 5.51308C4.66737 5.6146 4.65011 5.72341 4.65011 5.83329C4.65011 5.94317 4.66737 6.05198 4.70091 6.1535C4.73445 6.25501 4.78361 6.34726 4.84559 6.42495C4.90756 6.50265 4.98114 6.56429 5.06211 6.60634C5.14309 6.64839 5.22987 6.67003 5.31752 6.67003C5.40517 6.67003 5.49196 6.64839 5.57293 6.60634C5.6539 6.56429 5.72748 6.50265 5.78945 6.42495ZM13.9586 11.6666C13.7823 11.6666 13.6132 11.7544 13.4886 11.9107C13.3639 12.067 13.2939 12.2789 13.2939 12.5V15.8333C13.2939 16.0543 13.2238 16.2663 13.0992 16.4225C12.9745 16.5788 12.8055 16.6666 12.6292 16.6666H3.32343C3.14714 16.6666 2.97808 16.5788 2.85342 16.4225C2.72877 16.2663 2.65874 16.0543 2.65874 15.8333V12.5C2.65874 12.2789 2.58871 12.067 2.46405 11.9107C2.3394 11.7544 2.17033 11.6666 1.99404 11.6666C1.81775 11.6666 1.64869 11.7544 1.52403 11.9107C1.39938 12.067 1.32935 12.2789 1.32935 12.5V15.8333C1.32935 16.4963 1.53944 17.1322 1.9134 17.6011C2.28736 18.0699 2.79457 18.3333 3.32343 18.3333H12.6292C13.158 18.3333 13.6652 18.0699 14.0392 17.6011C14.4132 17.1322 14.6233 16.4963 14.6233 15.8333V12.5C14.6233 12.2789 14.5532 12.067 14.4286 11.9107C14.3039 11.7544 14.1349 11.6666 13.9586 11.6666Z"
                          fill="white"
                        />
                      </svg>
                      Chọn file
                    </button>
                    <input
                      class="d-none"
                      type="file"
                      @change="onSelectFile"
                      ref="inputFileTreatment"
                      :key="fileInputKey"
                    />
                  </div>
                  <div class="col-12">
                    <small class="text-red">{{ err_file }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="closeModal"
              type="button"
              class="btn btn-muted"
              data-dismiss="modal"
              @click="closeModal"
            >
              Huỷ
            </button>
            <button
              :disabled="is_loading"
              type="button"
              class="btn bg-pri bd-pri text-white"
              @click="onSubmit()"
            >
              Lưu
              <span
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                v-if="is_loading"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'ModalEMRTreatUpload',
  data () {
    return {
      content: '',
      err_file: '',
      exts_list: [
        'jpeg',
        'png',
        'jpg',
        'gif',
        'svg',
        'doc',
        'docx',
        'pdf',
        'xls',
        'xlsx',
        'xlsm',
        'ppt',
        'pptx'
      ],
      is_loading: false,
      form: {
        medical_record_id: null,
        name: 'Phiếu điều trị ngày ' + moment().format('DD-MM-YYYY'),
        date: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        format: 2,
        pdf: null,
        user_id: '',
        user_name: ''
      },
      file: null,
      loadingDoctor: false,
      doctors: [],
      doctorPaging: {},
      fileInputKey: 0
    }
  },
  mounted () {
    const self = this
    this.closeModal()
    this.getDoctor()

    window.$('#modalEmrTreatUpload').on('hidden.bs.modal', function (e) {
      self.closeModal()
    })
  },
  methods: {
    onSubmit () {
      let self = this
      if (self.is_loading) return
      if (!self.file) {
        self.err_file = 'Vui lòng chọn file'
        return false
      } else if (!self.validateFile(self.file)) {
        self.err_file =
          'Vui lòng chọn file có định dạng jpeg,png,jpg,gif,svg,doc,docx,pdf,xls,xlsx'
        return false
      } else {
        if (isNaN(this.form.user_id)) {
          this.form.user_name = this.form.user_id
          this.form.user_id = null
        } else {
          const doctor = this.doctors.find(
            (item) => (item.user_id = this.form.user_id)
          )
          this.form.user_name = doctor?.name || ''
        }
        this.form.medical_record_id = this.$route.params.id
        this.form.pdf = this.file
        this.form.date = moment(this.form.date)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
        self.$emit('onSubmit', this.form)
        this.closeModal()
      }
    },
    validateFile (file) {
      let ext = file.name.split('.').pop()
      return !!this.exts_list.find((el) => el === ext.toLowerCase())
    },
    onSelectFile (event) {
      this.file = event.target.files[0]
    },
    onShowPickFile () {
      this.err_file = ''
      this.$refs.inputFileTreatment.click()
      this.$refs.inputFileTreatment.value = null
    },
    closeModal () {
      this.$refs.inputFileTreatment.value = null
      this.file = null
      this.fileInputKey++
      this.form = {
        medical_record_id: null,
        name: 'Phiếu điều trị ngày ' + moment().format('DD-MM-YYYY'),
        date: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        format: 2,
        pdf: null,
        user_id: null
      }
    },
    getDoctor (search = null) {
      if (this.$globalClinic) {
        if (this.$globalClinic?.org_id) {
          this.getOrgDoctor(search)
        } else {
          this.getClinicDoctor(search)
        }
      }
    },
    async getOrgDoctor (search = null) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgDoctor(this.$globalClinic?.org_id, params)
        .then((r) => {
          this.doctors = r.data
          const hasMe = this.doctors.find((d) => d.user_id === this.$user.id)
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = r.meta
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getClinicDoctor (search) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getClinicDoctor(this.$globalClinic?.id, params)
        .then((r) => {
          this.doctors = r.data.data
          this.doctors.map((d) => {
            d.name = d.doctor?.name
            d.user_id = d.doctor?.user_id
          })
          const hasMe = this.doctors.find(
            (d) => d.doctor_id === this.$user?.doctor.id
          )
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = {
            count: r.data.count,
            current_page: r.data.current_page,
            last_page: r.data.last_page,
            per_page: r.data.per_page,
            total: r.data.total
          }
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    handleCurrentPage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({ query }).catch((_) => {})
      this.getVitalsignHeaders()
    }
  }
}
</script>
